import * as React from "react";
const SvgMsgIncoming = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 46, viewBox: "0 0 9 46", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.57883 1C7.57883 1 7.5 14.5 5.5 19C3.5 23.5 2 24 2 24C2 24 3.5 25 5.5 28.5C7.5 32 7.57883 45.9263 7.57883 45.9263" }));
export default SvgMsgIncoming;
